// src/pages/MyDrafts.jsx
import { useEffect, useState } from "react";
import AppLayout from "../layouts/AppLayout.jsx";
import DraftCard from "../components/DraftCard.jsx";
import API from "../config/api.js";

export default function MyDrafts() {
  const [drafts, setDrafts] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchDrafts = async () => {
    try {
      setLoading(true);

      const res = await fetch(`${API.myDrafts}?list`, {
        credentials: "include",
      });

      const data = await res.json();
      setDrafts(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error", error);
      setDrafts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDrafts();
  }, []);

  const handleRemoveDraft = (iddraft) => {
    setDrafts((prev) => prev.filter((draft) => draft.iddraft !== iddraft));
  };

  const handleQueuedDraft = (iddraft) => {
    setDrafts((prev) => prev.filter((draft) => draft.iddraft !== iddraft));
  };

  const placeholders = Array.from({ length: 8 }, (_, i) => (
    <div key={`placeholder-${i}`} className="col-md-4 col-lg-3 placeholder-item">
      <div className="card rounded-4 h-100 border animate__animated animate__fadeIn animate__slow">
        <div className="placeholder-glow">
          <div
            className="placeholder w-100 rounded-top-4"
            style={{ height: "180px" }}
          ></div>
        </div>
        <div className="card-body">
          <h5 className="card-title">
            <span className="placeholder col-7"></span>
          </h5>
          <p className="card-text">
            <span className="placeholder col-5"></span><br />
            <span className="placeholder col-4"></span>
          </p>
        </div>
        <div className="card-footer rounded-bottom-4 bg-transparent p-3">
          <div className="row align-items-center">
            <div className="col-auto">
              <button
                type="button"
                className="btn btn-outline-primary disabled placeholder"
                disabled
              >
                Loading...
              </button>
            </div>
            <div className="col text-end">
              <span className="placeholder col-1 me-2"></span>
              <span className="placeholder col-1"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  ));

  return (
    <AppLayout currentPage="my-drafts">
      <div className="container-fluid px-0">
        {loading ? (
          <div className="p-3">
            <div className="row g-2">
              {placeholders}
            </div>
          </div>
        ) : drafts.length ? (
          <div className="p-3">
            <div className="row g-2">
              {drafts.map((draft) => (
                <div key={draft.iddraft} className="col-md-4 col-lg-3">
                  <DraftCard
                    draft={draft}
                    onRemove={handleRemoveDraft}
                    onQueued={handleQueuedDraft}
                  />
                </div>
              ))}
            </div>
          </div>
        ) : (
          <p className="text-center">No drafts.</p>
        )}
      </div>
    </AppLayout>
  );
}